// Stripe.js loader — fetches the publishable key from /api/payments/config
// at runtime so key rotation (sandbox → live, or any admin swap) works
// without a rebuild. The Stripe.js promise is shared across the app so
// we only load it once per page.
import { loadStripe } from "@stripe/stripe-js";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let stripePromise = null;

const _fetchKeyAndLoad = async () => {
  try {
    const res = await fetch(`${API}/payments/config`);
    if (!res.ok) throw new Error(`config HTTP ${res.status}`);
    const data = await res.json();
    const key = data && data.publishable_key;
    if (!key) throw new Error("publishable_key missing from /payments/config");
    return await loadStripe(key);
  } catch (err) {
    // Reset so a future call can retry — one bad network moment shouldn't
    // permanently break payments.
    stripePromise = null;
    console.error("Stripe.js load failed:", err);
    return null;
  }
};

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = _fetchKeyAndLoad();
  }
  return stripePromise;
};
